// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"Breadcrumb_mainDiv__XN4m0","parentLink":"Breadcrumb_parentLink__cDuQj","title":"Breadcrumb_title__jvXay"};